//#region Libraries
//#endregion
//#region Styles
//#endregion
//#region Components
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomButton from "components/CustomButton/CustomButton";
import { useState } from "react";
import { useEffect } from "react";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const TEXT_LIST = {
    activation: {
        action: "activar",
        request: {
            loading: "Activando",
            success: "Activaste"
        },
        content: [
            "activada",
            "desactivarla"
        ]
    },
    desactivation: {
        action: "desactivar",
        request: {
            loading: "Desactivando",
            success: "Desactivaste"
        },
        content: [
            "desactivada",
            "activarla"
        ]
    }
};

const DialogToggleActivationResource = ({
    dialogShow,
    serviceName,
    cancelToggleActivationResource,
    toggleActivationResource,
    isServiceActive
}) => {
    const [textList, setTextList] = useState({
        action: "",
        request: {
            loading: "",
            success: ""
        },
        content: []
    });
    useEffect(() => {
        setTextList(isServiceActive 
            ? TEXT_LIST.activation
            : TEXT_LIST.desactivation);
    }, [isServiceActive]);
    return (
        <DialogAlertAction
            minWidth="400px"
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}
            close={cancelToggleActivationResource}
            variant="secondary"
            title={`¿Deseas ${textList.action} la ${serviceName}?`}
            content={`Recuerda que se visualizará ${textList.content[0]} y podrás ${textList.content[1]} volviendo a editar.`}>
            <CustomButton 
                variant="secondary"
                width="125px"
                text={`Si, ${textList.action}`}
                onClick={() => toggleActivationResource(textList.request)}/>
            <CustomButton 
                width="125px"
                text="No, cancelar"
                onClick={cancelToggleActivationResource}/>
        </DialogAlertAction>
    );
}

export default DialogToggleActivationResource;